import { useMutation, gql } from '@apollo/client'

const ADMIN_ACCESS_TOKEN_MUTATION = gql`
  mutation exchangeCustomTokenForAdminToken {
    exchangeCustomTokenForAdminToken
  }
`

export const useAdminAccessTokenMutation = (options) =>
  useMutation(ADMIN_ACCESS_TOKEN_MUTATION, options)
